import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { Subject, startWith, map } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AlertComponent } from '../alert/alert.component';
import { DataService } from '../data.service';
import { HttpService } from '../http.service';
import { MainpageComponent } from '../mainpage/mainpage.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToggleService } from '../toggle.service';
import { CreatedialogComponent } from '../createdialog/createdialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import DataTables from 'datatables.net';




@Component({
  selector: 'app-first-page',
  templateUrl: './first-page.component.html',
  styleUrls: ['./first-page.component.scss']
})
export class FirstPageComponent implements OnInit,AfterViewInit {
  city: any;
  cityid: any;
  streamid: any;
  classId: any;
  campus: any;
  campusId: any;
  classAndstream: any;
  stream: any;
  class: any;
  coursetrack: any;
  campuswisetracks: any
  list: any;
  cityName: any;
  cityOptions: any;
  campusName: any;
  campusOptions: any;
  className: any; 
  streamName: any;
  groupName: any;
  coursetrackName: any;
  classOptions: any;
  streamOptions: any;
  groupOptions: any;
  coursetrackOptions: any;
  campustrackOptions: any;
  routelink: String = "[creation]";
  filterBy: any = 'PENDING';
  YEAR: any;
  pendingImage: any = '../../assets/canedit.svg';
  editingRoute: any = 'goto()';
  pendingtick: any = 'none';
  approvedtick: any = 'none';
  rejectedtick: any = 'none';
  filterdisplay: any = 'none'
  campusTrackId: any;
  classname: any;
  courseTrackName: any;
  CampusWiseCourseTracks: any;
  grouplist: any;
  groupNameList: any;
  defaultCity: any;
  cityObject: any;
  campusObject: any;
  classObject: any;
  streamobject: any;
  coursetrackobject: any;
  groupobject: any;
  defaultCoursetrack: any;
  defaultCampus: any;
  defaultClass: any;
  defaultgroup: any;
  defaultstream: any;
  coursetrackcolor:any='#CAD2DE'
  coursetrackcolor1: string='#666';
  dataDisplay: any;
  displayvalue: string='flex';
  coursetrackid: any;
  groupId: any;
  groupwisestream: any;
  showComponent1 = true;
  showComponent2 = false;

  toggleComponents() {
    this.showComponent1 = !this.showComponent1;
    this.showComponent2 = !this.showComponent2;
  }
  constructor(private route: Router, private service: HttpService,private dtservice:DataService,private dialog:NgDialogAnimationService,private app:MainpageComponent) { }
  ngAfterViewInit(): void {
  }
  // dtOptions:DataTables.Settings = {};
  // dtTrigger: Subject<any> = new Subject<any>();
  main:any;
  ngOnInit(): void {
   
 
    $(document).ready(() => {
        $("#table").DataTable();})
    
  
    // this.dtTrigger.next(null);
    

    if(this.dtservice.campusId!=null)
    {
      this.defaultCity=this.dtservice.getcityName()
      this.defaultCampus=this.dtservice.getcampusName()
      this.defaultClass=this.dtservice.getclassName()
      this.defaultgroup=this.dtservice.getgroupName()
      this.defaultstream=this.dtservice.getstreamName()
      this.defaultCoursetrack=this.dtservice.getcoursetrackName()
      this.coursetrackobject=this.dtservice.coursetrack;
      this.getlistAftersave(this.dtservice.campusId,this.dtservice.classId,this.dtservice.streamId,this.dtservice.coursetrack.courseTrackId,this.dtservice.group.groupId)
      this.main=new FormGroup({
        "citycontrol":new FormControl(),
        "campusControl":new FormControl(),
        "classControl":new FormControl(),
        "streamcontrol":new FormControl(),
        "groupcontrol":new FormControl(),
        "coursetrackcontrol":new FormControl(),
        "citycontrol2":new FormControl(this.dtservice.getcityName()),
        "campusControl2":new FormControl(this.dtservice.getcampusName()),
        "classControl2":new FormControl(this.dtservice.getclassName()),
        "streamcontrol2":new FormControl(this.dtservice.getstreamName()),
        "groupcontrol2":new FormControl(this.dtservice.getgroupName()),
        "coursetrackcontrol2":new FormControl(this.dtservice.getcoursetrackName())
      })
    }
    else{
         this.main=new FormGroup({
      "citycontrol":new FormControl(),
      "campusControl":new FormControl(),
      "classControl":new FormControl(),
      "streamcontrol":new FormControl(),
      "groupcontrol":new FormControl(),
      "coursetrackcontrol":new FormControl(),
      "citycontrol2":new FormControl(),
      "campusControl2":new FormControl(),
      "classControl2":new FormControl(),
      "streamcontrol2":new FormControl(),
      "groupcontrol2":new FormControl(),
      "coursetrackcontrol2":new FormControl()
    })
    }
  

    // this.service.getCity().subscribe((res: any) => {
    //   this.city = res;
    //   this.cityOptions = this.main.get('citycontrol').valueChanges.pipe(
    //     startWith(''),
    //     map((value:any) => this.Filter(value,this.city,'cityName' || ''))
    //   );
    // });
    
    
  }
  openCreateDialog()
  {
    const dialogref=this.dialog.open(CreatedialogComponent,{
      width:"400px",
      height: "1000px",
     panelClass: [ 'animate__animated', 'animate__slideInRight'],
     position: { right: '0' },
     maxWidth: '100%',
     animation: { to: 'left' },
     autoFocus:false,
     disableClose :false,
     hasBackdrop:false,
     id:"create"
    })
    dialogref.afterClosed().subscribe(res=>{
      this.list=res.list
       if(res.value)
        {
          this.goto()
        }
      $('#table').DataTable().destroy();
      $(document).ready(() => {
          $("#table").DataTable();})
      
    })
    dialogref.afterOpened().subscribe(res=>{
      $('#table').DataTable().destroy();
      $(document).ready(() => {
          $("#table").DataTable();})
    })
  }
  getcity(){
   
  }
  clearcampus() {
    this.main.get('campusControl2').reset();
   this.defaultCampus=''
    this.clearclass();
  }
  
  clearclass() {
    this.main.get('classControl2').reset();
    this.defaultClass=''
    this.clearGroup()
    
  }
  
  clearstream() {
    this.main.get('streamcontrol2').reset();
    this.defaultstream=''
    this.clearcoursetrack();
  }
  
  clearcoursetrack() {
    this.main.get('coursetrackcontrol2').reset();
    this.defaultCoursetrack=''
  }
  
  clearGroup() {
    this.main.get('groupcontrol2').reset();
    this.defaultgroup=''
    this.clearstream();
  }
  
  filterDisplay() {
    this.filterdisplay = 'flex';
  }
  changeFilter(value: any) {
    this.filterBy = value;
    if (value == 'pending') {
      this.pendingtick = 'flex';
      this.approvedtick = 'none'
      this.rejectedtick = 'none';

    }
    else if (value == 'approved') {
      this.pendingtick = 'none';
      this.approvedtick = 'flex'
      this.rejectedtick = 'none';
    }
    else {
      this.pendingtick = 'none';
      this.approvedtick = 'none'
      this.rejectedtick = 'flex';
    }
    this.getlist();
    this.filterdisplay = 'none';
  }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
}

  getcityid(city: any) {
    this.dtservice.setCity(city);
    
    this.cityObject=city;
        this.service.getCampus(city.cityId).subscribe((res: any) => {
          this.campus = res;
          this.campusOptions = this.main.get('campusControl').valueChanges.pipe(
            startWith(''),
            map((value:any) => this.Filter(value ,this.campus,'campusName'))
          )
        });
      
  }
  closefilterDisplay()
  {
    this.filterdisplay='none';
  }
  getclass(campus: any) {
    this.dtservice.setCampus(campus)
      this.campusObject=campus;
        this.campusId=campus.campusId;
        this.dtservice.setCampusID(this.campusId)
        this.service.getClassAndStream(this.campusId).subscribe((res: any) => {
          this.classAndstream = res
          this.stream = res.classWiseStreams;
          this.class = res.studyClassList;
          this.classOptions = this.main.get('classControl').valueChanges.pipe(
            startWith(''),
            map((value:any) => this.Filter(value,this.class,'className' ))
          )
        });
       
  }
  streamList: any;
  getclassId(classid: any) {
        this.dtservice.setClass(classid)
        this.classId = classid.id;
        this.classname=classid.className;
   this.dtservice.setClassID(this.classId)

   
    this.classObject=classid;
    this.getgroup();
   
  }
  getcourseTrack(streamid: any) {
        this.dtservice.setStream(streamid)
        this.streamid = streamid.streamId;
     this.dtservice.setStreamID(this.streamid)
    this.service.getCourseTrack(this.campusId, this.classId, this.streamid).subscribe((res: any) => {
      this.CampusWiseCourseTracks=res.CampusWiseCourseTracks;
      this.campustrackOptions = this.main.get('coursetrackcontrol').valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.CampusWiseCourseTracks,'courseTrackName' ))
      );
    });
    
    this.streamobject=streamid
  }
  setcoursetrackid(CampusWiseCourseTracks:any)
  {
    this.dtservice.setcoursetrack(CampusWiseCourseTracks)
    this.coursetrackid=CampusWiseCourseTracks.courseTrackId
    this.campusTrackId= CampusWiseCourseTracks.campusTrackId;
    this.coursetrackobject=CampusWiseCourseTracks;
    this.dtservice.setcoursetrackID(this.campusTrackId)
    this.getlist();
    this.coursetrackcolor='#CAD2DE'
    this.coursetrackcolor1='#666'
  }
  verifycoursetrack()
  {
    if(this.coursetrackobject==null)
    { 
      const data='Please Enter CourseTrackDetails'
      this.dialog.open(AlertComponent, {
        width: '800px',
        position: {right:'20px', top: '20px'},
        data: { data }
      });
      this.coursetrackcolor='red'
      this.coursetrackcolor1='red'
    }
    else if( this.coursetrackobject!=null)
    {
      
      this.goto()
    } 
  }
  verifyCourseTrack2(value:any,editornot:boolean)
  {
    this.goto()
   this.dtservice.courseFeeID=this.list[value].courseFeeId;
   this.dtservice.editornot=editornot;

  }
  getlist() {
    
    this.service.getList(this.campusId, this.classId, this.streamid, this.filterBy,this.coursetrackid,this.groupId)
      .subscribe((res: any) => {
        this.list = res;
        $('#table').DataTable().destroy();
      });
     

  }

   getlistAftersave(campusid:any,classid:any,streamid:any,coursetrackid:any,groupId:any)
   {
    this.campusId=campusid;
    this.classId=classid;
    this.streamid=streamid;
    this.service.getList(campusid, classid, streamid, this.filterBy,coursetrackid,groupId)
    .subscribe((res: any) => {
      this.list = res;
      $('#table').DataTable().destroy();
      $(document).ready(() => {
          $("#table").DataTable();})
    })
   }
  goto() {
      //  this.route.navigate(['/creation']);
      // this.route.navigate([''], { queryParams: { component: 'SecondpageComponent' } });
    // this.route.navigateByUrl("creation");
    this.app.toggleComponents()
  }
  getGroupobj(item:any)
  {

    this.groupobject=item;
    this.groupId=item.groupId
    this.groupwisestream=this.grouplist.groupWiseStreams

    for (let i = 0; i < this.groupwisestream.length; i++) {
      if (this.groupwisestream[i].groupId == this.groupId) {
        this.streamList = this.groupwisestream[i].StreamList;
        this.streamOptions = this.main.get('streamcontrol').valueChanges.pipe(
          startWith(''),
          map((value:any) => this.Filter(value,this.streamList,'streamName' ))
        )

      }
    }
    this.dtservice.setGroup(item)
  }
  getgroup()
  {
    this.service.getGroup(this.campusId,this.classId).subscribe((res:any)=>
    {
      this.grouplist=res;
      
      this.groupNameList=this.grouplist.groupNameList;
      this.groupName= this.groupNameList.map((grouplist:any)=>grouplist.groupName);
      this.groupOptions=this.main.get('groupcontrol').valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.groupNameList,'groupName' ))
      )
    })
  }
}
